import * as React from 'react';

import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface InteractiveCardProps extends React.HTMLAttributes<HTMLDivElement> {
    interactive?: boolean;
    hoverable?: boolean;
    selected?: boolean;
}

const InteractiveCard = React.forwardRef<HTMLDivElement, InteractiveCardProps>(
    (
        { className, interactive = false, hoverable = interactive, selected = false, ...props },
        ref,
    ) => (
        <Card
            ref={ref}
            className={cn(
                'flex h-full flex-col overflow-hidden border-border/80 bg-card/95 shadow-elevation-1',
                'transition-[border-color,box-shadow,transform] duration-200 ease-out',
                hoverable &&
                    'hover:-translate-y-0.5 hover:border-brand/20 hover:shadow-elevation-2',
                interactive &&
                    'cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
                selected && 'border-brand/25 bg-brand-subtle/70 shadow-elevation-1',
                className,
            )}
            {...props}
        />
    ),
);

InteractiveCard.displayName = 'InteractiveCard';

export default InteractiveCard;
